import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { RequestResponse } from 'src/app/shared/models/request-response.interface'
import { Observable, throwError } from 'rxjs'


@Injectable({
    providedIn: 'root'
})

export class HorasExtrasService {
    constructor(
        private http: HttpClient,
        private alert: AlertHelper,
        private router: Router
    ) { }
    //ESTO NO PERTENECE AQUÍ, PERO SI SE COMENTA O SE QUITA, SE CAE EL SISTEMA ASDA XD
    TraerTrabajadores(): Observable<RequestResponse> {
      return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/trabajador/`)
      .pipe(
        map((res: RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //Eliminar
    eliminarHorasExtra(id:number): Observable<RequestResponse> {
      return this.http
      .delete<RequestResponse >(`${environment.API}/rrhh/horasExtras/eliminar/${id}`)
      .pipe(
        map((res:RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //crear
    crearHorasExtras(horasExtras:any): Observable<RequestResponse> {        
      return this.http
      .post<RequestResponse >(`${environment.API}/rrhh/horasExtras/crear`,horasExtras)
      .pipe(
        map((res:RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //ObtenerTodo
  traerTodasHorasExtra(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/horasExtras`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerTodoAsync
  async traerTodasHorasExtraAsync(): Promise<RequestResponse> {
    try {
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/horasExtras`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener las horas extras'} as RequestResponse
    }
  }
    //TraerPorId
    traerHoraExtraId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/horasExtras/${id}`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRutMesActual
  traerPorTrabajadorActual(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/horasExtras/idTrabajador/${id}`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRut
  traerTodasTrabajador(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/horasExtras/horasTrabajador/${id}`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRutAsync
  async traerTodasTrabajadorAsync(id: number): Promise<RequestResponse> {
    try {
      
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/horasExtras/horasTrabajador/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener las horas extras.'} as RequestResponse
    }
  }

  //lista_horas SE COMENTA, NO SE LLAMA EN NI UNA PARTE Y NO EXISTE ESTA RUTA EN EL BACK
  // listaHorasExtra(): Observable<RequestResponse> {
  //   return this.http
  //   .get<RequestResponse >(`${environment.API}/rrhh/horasExtras/listar`)
  //   .pipe(
  //     map((res:RequestResponse) =>{ 
  //       return res;
  //     }),
  //     catchError((err)=> this.handlerError(err))
  //   );
  //   }

    //Update_horaExtra
    actualizarHoraExtra(horasExtras: any): Observable<RequestResponse> {
      return this.http
          .put<RequestResponse>(`${environment.API}/rrhh/horasExtras/actualizar/ ${horasExtras.id}`, horasExtras)
          .pipe(
              map((res: RequestResponse) => {
                  return res;
              }),
              catchError((err) => this.handlerError(err))
          )
  }
    
    private handlerError(err: any): Observable<never> {
        let errorMessage = ""
        if (err) {
            errorMessage = `Error: ${err.error.msg}`
        }
        this.alert.error_small(err.error.msg)
        return throwError(errorMessage)
    }
}